<template lang="html">
  <div class="wrap">
    <div v-if="isLoading" class="mt-5 text-xs-center">
      <v-progress-circular :size="70" :width="5" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else class="image">
      <div class="text">
        <v-content>
          <div v-if="page == 1">
            <v-layout column align-center style="margin-bottom: 10%;" class="white--text">
              <img src="/static/img/icons/logo.png" height="150" class="mb-4">
              <!-- <img src="/static/img/icons/INETREIT.png" height="180" class="mb-4"> -->
              <h1 style="font-weight: 700; font-size: 45px!important;" class="mb-4 display-1 text-xs-center">{{ meetingInfo.titleEN }}</h1>
              <div style="font-weight: 700; font-size: 40px!important;" class="subheading text-xs-center">{{ meetingInfo.title }}</div>
              <div style="font-weight: 700; font-size: 24px!important; margin-top: 1.5em;" class="subheading text-xs-center">บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)</div>
              <!-- <div style="font-weight: 700; font-size: 24px!important; margin-top: 1.5em;" class="subheading text-xs-center">ทรัสต์เพื่อการลงทุนในอสังหาริมทรัพย์และสิทธิการเช่าอสังหาริมทรัพย์ไอเน็ต</div> -->
            </v-layout>
          </div>
          <div v-if="page == 2">
            <v-content style="padding: 0px; margin: 0px auto; width: 95%; height: 100%;">
              <section>
                <v-layout row wrap class="border">

                  <v-flex xs12>
                    <v-flex xs12>
                      <h1 style="font-size: 40px; margin-bottom: 30px;" class="black--text">ผู้ถือหุ้น</h1>
                    </v-flex>

                    <v-flex class="mb-3" xs12>
                      <v-layout row wrap class="pl-4">
                        <v-flex xs6>
                          <h2 class="mr-5 black--text meetingInfoFont">จำนวนหุ้นทั้งหมด</h2>
                        </v-flex>
                        <v-flex xs5>
                          <h2 class="black--text f-r meetingInfoFont">{{ setQShare(meetingInfo.allQShare) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">หุ้น</h2>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex class="mb-3" xs12>
                      <v-layout row wrap class="pl-4">
                        <v-flex xs6>
                          <h2 class="mr-5 black--text meetingInfoFont">จำนวนผู้ถือหุ้น</h2>
                        </v-flex>
                        <v-flex xs5>
                          <h2 class="black--text f-r meetingInfoFont">{{ setQShare(meetingInfo.countMember) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">ราย</h2>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-divider class="my-4"></v-divider>
                    <v-flex class="mb-3" xs12>
                      <v-layout row wrap class="pl-4">
                        <v-flex xs6>
                          <h2 class="mr-5 black--text meetingInfoFont">จำนวนหุ้นที่ลงทะเบียน</h2>
                        </v-flex>
                        <v-flex xs5>
                          <h2 :class="setColor(meetingInfo.allQShare_registered, 'qshare')">{{ setQShare(meetingInfo.allQShare_registered) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">หุ้น</h2>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="mb-3" xs12>
                      <v-layout row wrap class="pl-4">
                        <v-flex xs6>
                          <h2 class="mr-5 black--text meetingInfoFont">คิดเป็นร้อยละ</h2>
                        </v-flex>
                        <v-flex xs5>
                          <h2 class="black--text f-r meetingInfoFont">{{ setPercent(meetingInfo.allQShare_registered_percent, 'agenda') }}</h2>
                        </v-flex>
                        <v-flex xs1>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex class="mb-3" xs12>
                      <v-layout row wrap class="pl-4">
                        <v-flex xs6>
                          <h2 class="mr-5 black--text meetingInfoFont">จำนวนผู้ลงทะเบียน</h2>
                        </v-flex>
                        <v-flex xs5>
                          <h2 :class="setColor(meetingInfo.countMember_registered, 'member')">{{ setQShare(meetingInfo.countMember_registered) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">ราย</h2>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="mb-3" xs12>
                      <v-layout row wrap class="pl-4">
                        <v-flex xs3>
                          <h2 class="black--text meetingInfoFont">
                            <li>ผู้มาลงคะแนนด้วยตัวเอง</li>
                          </h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="black--text f-r meetingInfoFont">{{ setQShare(meetingInfo.countMember_registered_self) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">ราย</h2>
                        </v-flex>
                        <v-flex xs2>
                          <h2 class="black--text f-r meetingInfoFont">{{ setQShare(meetingInfo.sumQShare_Member_registered_self) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">หุ้น</h2>
                        </v-flex>
                        <v-flex xs2>
                          <h2 class="pl-4 meetingInfoFont">คิดเป็นร้อยละ</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="black--text f-r meetingInfoFont">{{ setPercent(meetingInfo.QShare_registered_self_percent, 'agenda') }}</h2>
                        </v-flex>
                        <v-flex xs1>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex class="mb-1" xs12>
                      <v-layout row wrap class="pl-4">
                        <v-flex xs3>
                          <h2 class="black--text meetingInfoFont">
                            <li>ผู้มอบฉันทะ</li>
                          </h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="black--text f-r meetingInfoFont">{{ setQShare(meetingInfo.countMember_registered_proxy) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">ราย</h2>
                        </v-flex>
                        <v-flex xs2>
                          <h2 class="black--text f-r meetingInfoFont">{{ setQShare(meetingInfo.sumQShare_Member_registered_proxy) }}</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="pl-4 meetingInfoFont">หุ้น</h2>
                        </v-flex>
                        <v-flex xs2>
                          <h2 class="pl-4 meetingInfoFont">คิดเป็นร้อยละ</h2>
                        </v-flex>
                        <v-flex xs1>
                          <h2 class="black--text f-r meetingInfoFont">{{ setPercent(meetingInfo.QShare_registered_proxy_percent, 'agenda') }}</h2>
                        </v-flex>
                        <v-flex xs1>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page == (3 + index)" v-for="item, index in agendaVote">
            <v-content v-if="item.agenda != ''" style="padding: 0px; margin: 0px auto; width: 95%; height: 100%;">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h1 style="font-size: 33px;" class="black--text mb-2" v-html="'วาระที่ '+ item.agenda + ' ' + item.title"></h1>
                    </v-flex>

                    <img v-if="item.imagepath" style="display: block; margin: 0 auto;" v-bind:src="'/static/img/icons/' + item.imagepath" height="230" class="mb-4">

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left; margin-bottom: 50px;"><h2>เห็นด้วย</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.accept) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <td style="text-align: right;"><h2>{{ setPercent(item.percent_accept, 'agenda') }} %</h2></td>
                      </tr>
                      <tr>
                        <td style="text-align: left;"><h2>ไม่เห็นด้วย</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.noaccept) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <td style="text-align: right;"><h2>{{ setPercent(item.percent_noaccept, 'agenda') }} %</h2></td>
                      </tr>
                      <tr>
                        <td style="text-align: left;"><h2>งดออกเสียง</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.abstain) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <td style="text-align: right;" v-if="item.presentationtype == 2 || item.presentationtype == 4"><h2>{{ setPercent(item.percent_abstain, 'agenda') }} %</h2></td>
                      </tr>
                      <tr>
                        <td style="text-align: left;"><h2>บัตรเสีย</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.broke) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <td style="text-align: right;" v-if="item.presentationtype == 1 || item.presentationtype == 2"><h2>{{ setPercent(item.percent_broke, 'agenda') }} %</h2></td>
                      </tr>
                      <!-- <tr>
                        <td style="text-align: left;"><h2>รวม</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.accept + item.noaccept + item.abstain + item.broke) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <td style="text-align: right;"><h2>{{ setPercent(item.percent_accept + item.percent_noaccept + item.percent_abstain + item.percent_broke, 'agenda') }} %</h2></td>
                      </tr> -->
                    </table>

                  </v-flex>

                </v-layout>
              </section>
            </v-content>
            <v-content v-else style="padding: 0px; margin: 0px auto; width: 95%; height: 100%;">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h1 style="font-size: 33px;" class="black--text mb-2" v-html="item.agenda + ' ' + item.title"></h1>
                    </v-flex>

                    <img v-if="item.imagepath" style="display: block; margin: 0 auto;" v-bind:src="'/static/img/icons/' + item.imagepath" height="230" class="mb-4">

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left; margin-bottom: 50px;"><h2>เห็นด้วย</h2></td>
                        <td style="text-align: right;"><h2 :class="setColorVote(item.accept, 'qshare')">{{ setQShare(item.accept) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <!-- <td style="text-align: right;"><h2>{{ setPercent(item.percent_accept, 'agenda') }} %</h2></td> -->
                      </tr>
                      <tr>
                        <td style="text-align: left;"><h2>ไม่เห็นด้วย</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.noaccept) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <!-- <td style="text-align: right;"><h2>{{ setPercent(item.percent_noaccept, 'agenda') }} %</h2></td> -->
                      </tr>
                      <tr>
                        <td style="text-align: left;"><h2>งดออกเสียง</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.abstain) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <!-- <td style="text-align: right;" v-if="item.presentationtype == 2 || item.presentationtype == 4"><h2>{{ setPercent(item.percent_abstain, 'agenda') }} %</h2></td> -->
                      </tr>
                      <tr>
                        <td style="text-align: left;"><h2>บัตรเสีย</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.broke) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <!-- <td style="text-align: right;" v-if="item.presentationtype == 1 || item.presentationtype == 2"><h2>{{ setPercent(item.percent_broke, 'agenda') }} %</h2></td> -->
                      </tr>
                      <!-- <tr>
                        <td style="text-align: left;"><h2>รวม</h2></td>
                        <td style="text-align: right;"><h2>{{ setQShare(item.accept + item.noaccept + item.abstain + item.broke) }}</h2></td>
                        <td style="text-align: left; padding-left: 10px;"><h2>หุ้น</h2></td>
                        <td style="text-align: right;"><h2>{{ setPercent(item.percent_accept + item.percent_noaccept + item.percent_abstain + item.percent_broke, 'agenda') }} %</h2></td>
                      </tr> -->
                    </table>

                  </v-flex>

                </v-layout>
              </section>
            </v-content>
          </div>
          <!-- <div v-if="page==3">
            <v-content style="padding: 0px; margin: 0px auto; width: 75%; height: 100%;">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[1].agenda }} {{ agendaVote[1].title }}</h2>
                    </v-flex>

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[1].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[1].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[1].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[1].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>

                  </v-flex>

                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page==4">
            <v-content style="padding: 0px; margin: 0px auto; width: 75%; height: 100%;">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[2].agenda }} {{ agendaVote[2].title }}</h2>
                    </v-flex>

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[2].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[2].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[2].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[2].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>
                  </v-flex>

                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page==5">
            <v-content style="padding: 0px; margin: 0px auto; height: 100%">
              <v-layout row wrap class="border">
                <v-flex xs12>
                  <v-flex xs12>
                    <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[3].agenda }}.{{ agendaVote[3].subAgenda }} {{ agendaVote[3].title }}</h2>
                  </v-flex>
                  <img style="display: block; margin: 0 auto;" v-bind:src="'/static/img/icons/' + agendaVote[3].imagePath" height="250" class="mb-5">

                  <table style="width: 100%; text-align:center;">
                    <tr>
                      <td style="text-align: left;">เห็นด้วย</td>
                      <td style="text-align: right;">{{ agendaVote[3].accept }}</td>
                      <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                      <td style="text-align: right;">99.9853 %</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">ไม่เห็นด้วย</td>
                      <td style="text-align: right;">{{ agendaVote[3].noaccept }}</td>
                      <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                      <td style="text-align: right;">0.0147 %</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">งดออกเสียง</td>
                      <td style="text-align: right;">{{ agendaVote[3].abstain }}</td>
                      <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                      <td style="text-align: right;">0 %</td>
                    </tr>
                    <tr>
                      <td style="text-align: left;">บัตรเสีย</td>
                      <td style="text-align: right;">{{ agendaVote[3].broke }}</td>
                      <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                      <td style="text-align: right;">0 %</td>
                    </tr>
                  </table>

                </v-flex>
              </v-layout>
            </v-content>
          </div>
          <div v-if="page==6">
            <v-content style="padding: 0px; margin: 0px auto; height: 100%;">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[4].agenda }}.{{ agendaVote[4].subAgenda }} {{ agendaVote[4].title }}</h2>
                    </v-flex>
                    <img style="display: block; margin: 0 auto;" v-bind:src="'/static/img/icons/' + agendaVote[4].imagePath" height="250" class="mb-5">

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[4].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[4].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[4].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[4].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>

                  </v-flex>
                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page==7">
            <v-content style="padding: 0px; margin: 0px auto; height: 100%;">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[5].agenda }}.{{ agendaVote[5].subAgenda }} {{ agendaVote[5].title }}</h2>
                    </v-flex>
                    <img style="display: block; margin: 0 auto;" v-bind:src="'/static/img/icons/' + agendaVote[5].imagePath" height="250" class="mb-5">

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[5].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[5].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[5].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[5].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>

                  </v-flex>
                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page==8">
            <v-content style="padding: 0px; margin: 0px auto; height: 100%;">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[6].agenda }}.{{ agendaVote[6].subAgenda }} {{ agendaVote[6].title }}</h2>
                    </v-flex>
                    <img style="display: block; margin: 0 auto;" v-bind:src="'/static/img/icons/' + agendaVote[6].imagePath" height="250" class="mb-5">

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[6].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[6].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[6].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[6].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>

                  </v-flex>
                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page==9">
            <v-content style="">
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[7].agenda }} {{ agendaVote[7].title }}</h2>
                    </v-flex>

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[7].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[7].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[7].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[7].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>

                  </v-flex>
                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page==10">
            <v-content>
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[8].agenda }} {{ agendaVote[8].title }}</h2>
                    </v-flex>

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[8].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[8].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[8].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[8].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>

                  </v-flex>
                </v-layout>
              </section>
            </v-content>
          </div>
          <div v-if="page==11">
            <v-content>
              <section>
                <v-layout row wrap class="border">
                  <v-flex xs12>
                    <v-flex xs12>
                      <h2 style="font-size: 30px;" class="black--text text-xs-left mb-5">วาระที่ {{ agendaVote[9].agenda }} {{ agendaVote[9].title }}</h2>
                    </v-flex>

                    <table style="width: 100%; text-align:center;">
                      <tr>
                        <td style="text-align: left;">เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[9].accept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">99.9853 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">ไม่เห็นด้วย</td>
                        <td style="text-align: right;">{{ agendaVote[9].noaccept }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0.0147 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">งดออกเสียง</td>
                        <td style="text-align: right;">{{ agendaVote[9].abstain }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                      <tr>
                        <td style="text-align: left;">บัตรเสีย</td>
                        <td style="text-align: right;">{{ agendaVote[9].broke }}</td>
                        <td style="text-align: left; padding-left: 10px;">หุ้น</td>
                        <td style="text-align: right;">0 %</td>
                      </tr>
                    </table>

                  </v-flex>
                </v-layout>
              </section>
            </v-content>
          </div> -->

          <div v-if="page == (3 + agendaVote.length)">
            <v-layout style="margin-bottom: 15%;" column align-center justify-center class="white--text">
              <img src="/static/img/icons/logo.png" height="150" class="mb-4">
              <!-- <img src="/static/img/icons/INETREIT.png" height="180" class="mb-4"> -->
              <!-- <h1 class="white--text mb-4 display-1 text-xs-center">Extraordinary General Meeting of Shareholders No. 1 / {{ new Date().getFullYear() }}</h1>
              <div class="white--text subheading text-xs-center">การประชุมวิสามัญผู้ถือหุ้น ครั้งที่ 1 / {{ new Date().getFullYear() }}</div> -->
              <h1 class="white--text mb-4 display-1 text-xs-center">{{ meetingInfo.titleEN }}</h1>
              <div class="white--text subheading text-xs-center">{{ meetingInfo.title }}</div>
              <!-- <h1 style="font-weight: 700; font-size: 40px!important;" class="text-xs-center">Thank you to all unitholders who attended the meeting.</h1>
              <h1 style="font-weight: 700; font-size: 40px!important;" class="text-xs-center">ขอขอบคุณผู้ถือหน่วยทุกท่านที่เข้าร่วมประชุม</h1> -->
            </v-layout>
          </div>

          <v-footer style="background-color: green;">
            <v-flex xs6 pl-3 text-xs-left white--text>
              &copy; {{ new Date().getFullYear() }} Internet Thailand Public Company Limited
              <!-- &copy; {{ new Date().getFullYear() }} INET REIT Management -->
            </v-flex>
            <v-flex xs6 text-xs-right pr-3>
              {{setDate}}
            </v-flex>
          </v-footer>

        </v-content>
      </div>
    </div>
  </div>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      isLoading: false,
      // arr: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10', 'page11', 'page12', 'page13'],
      entrie: [
        {
          'shareholders': '500,041,575',
          'personshareholders': '3,991',
          'regisshareholders': '272,143,752',
          'percent': '54.42',
          'regisperson': '84',
          'membershareholders': '53',
          'proxyshareholders': '31'
        }
      ],
      meetingInfo: {},
      agendaVote: [],
      page: 1
    }
  },
  sockets: {
    showPresentation: function () {
      this.getInfo()
    }
  },
  computed: {
    userData () {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_information')))
      } else {
        return ''
      }
    },
    termYear () {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(Decode.decode(this.$cookies.get('shareholder_termyear')))
      } else {
        return ''
      }
    },
    setDate () {
      var someDate = new Date()
      return someDate.toLocaleDateString('th-TH', { day: 'numeric', month: 'long', year: 'numeric' })
    }
  },
  created () {
    this.isLoading = true
    this.getInfo()
  },
  methods: {
    setColor (data, type) {
      if (type === 'qshare') {
        if (this.meetingInfo.min_qshare > data) {
          return ['red--text f-r meetingInfoFont']
        } else {
          return ['green--text f-r meetingInfoFont']
        }
      } else {
        if (this.meetingInfo.min_member > data) {
          return ['red--text f-r meetingInfoFont']
        } else {
          return ['green--text f-r meetingInfoFont']
        }
      }
    },
    setColorVote (data, type) {
      if (type === 'qshare') {
        if (this.meetingInfo.min_qshare > data) {
          return ['red--text']
        } else {
          return ['green--text']
        }
      } else {
        if (this.meetingInfo.min_member > data) {
          return ['red--text']
        } else {
          return ['green--text']
        }
      }
    },
    nextItem () {
      if (this.page === this.agendaVote.length + 3) {
        this.page = 1
      } else {
        this.page = this.page + 1
      }
    },
    prevItem () {
      if (this.page === 1) {
        this.page = this.agendaVote.length + 3
      } else {
        this.page = this.page - 1
      }
    },
    getInfo () {
      var source = { term: this.termYear.term, year: this.termYear.year }
      this.axios.post(process.env.API + '/getPresentationInfo', source).then((response) => {
        var result = response.data
        console.log(result)
        if (result.status === 'success') {
          this.meetingInfo = result.info
          this.agendaVote = result.agenda
          this.isLoading = false
        } else {
          this.isLoading = false
        }
      })
    },
    setPercent (number, type) {
      if (type === 'agenda') {
        if (number === '0.0000..') {
          return number
        } else if (number === 0) {
          return '0.0000'
          // return 0
        }
        return parseFloat(number).toFixed(4)
      } else {
        if (number === '0.00..') {
          return number
        } else if (number === 0) {
          return 0
          // return 0
        }
        return parseFloat(number).toFixed(2)
      }
    },
    setQShare (number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 })
    }
  },
  mounted () {
    window.addEventListener('keyup', event => {
      if (event.keyCode === 37) {
        this.prevItem()
      } else if (event.keyCode === 39) {
        this.nextItem()
      }
    })
    window.addEventListener('click', this.nextItem)
  }
  // beforeDestroy () {
  //   window.removeEventListener('click', this.nextItem)
  // }
}
</script>

<style lang="css" scoped>
.wrap {
  width: 100%;
}
.image {
  justify-content: center;
  display: flex;
  align-items: center;
  background-image: url('/static/img/icons/bg4.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  position: relative;
}
.image:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
}
.text {
  position: relative;
  width: 100%;
}
.border{
  border-radius: 1em;
  border-spacing: 200px 240px;
  padding: 2em 2em;
  /* opacity: 0.9; */
  background: #ffffff;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: red;
  color: white !important;
  text-align: center;
}
/* .centerDiv{
margin: 0;
position: absolute;
top: 55%;
left: 50%;
margin-right: -50%;
transform: translate(-50%, -50%);
} */
table, th, td {
  border: 1px solid white;
}
table {
  border-collapse: collapse;
}
td {
  width: 45px;
  padding-top: 16px;
  overflow: hidden;
  white-space: nowrap;
  font-size: 20px;
}
h2 {
  font-size: 25px;
  margin-bottom: 35px;
}
span {
  font-size: 20px;
}
.meetingInfoFont {
  font-size: 25px;
  margin-bottom: 12px;
}
.content, .content:before{
  position: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Pdf/Presentation.vue